import React, { FC, MouseEvent, useCallback } from "react";
import { reduceLink } from "./utils";

export interface SmartLinkProps {
    readonly url: string;
    readonly className?: string;
}

export const SmartLink: FC<SmartLinkProps> = props => {
    const { url, className } = props;

    const handleClick = useCallback((ev: MouseEvent) => {
        ev.preventDefault();
    }, []);

    return (
        <a
            href={url}
            aria-label="read more"
            target="_blank"
            rel="noreferrer"
            className={className}
            onClick={handleClick}
        >{reduceLink(url, 40)}</a>
    );
};
